// extracted by mini-css-extract-plugin
module.exports = {"disabledText":"clinical-portal-3__DataNotAvailableText__disabledText"};